import { FormGroup, ValidationErrors } from "@angular/forms"

export const atLeastOneSelected= (controlA: string, controlB: string) => {
    return (fg: FormGroup): ValidationErrors | null => {
        const controlAHasValue = !!fg.controls[controlA].value;
        const controlBHasValue = !!fg.controls[controlB].value;

        if (controlAHasValue || controlBHasValue) return null;
        return { notOsSelected: true };
    }
}